import classNames from 'classnames';
import React from 'react';

interface Props {
  active: boolean;
  className?: string;
  striped: boolean;
  value: number;
  type?: string;
}

export default function ProgressBar(props: Props): JSX.Element {
  return (
    <div
      className={classNames(props.className, 'progress', {
        'progress-striped': props.striped,
        active: props.active && props.striped, // `active` only has a visual impact if `striped`
      })}
    >
      <div
        role="progressbar"
        className={classNames({
          'progress-bar': true,
          'progress-bar-success': props.type === 'success',
          'progress-bar-warning': props.type === 'warning',
          'progress-bar-danger': props.type === 'danger',
          'progress-bar-onboarding': props.type === 'onboarding',
        })}
        style={{
          width: `${props.value}%`,
        }}
      />
    </div>
  );
}
ProgressBar.defaultProps = {
  active: false,
  striped: false,
};
